import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div className="flex items-center gap-3">
        <span className="h-6 w-1 rounded-full bg-accent-500" aria-hidden="true" />
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            {title}
          </h2>
          {subtitle ? (
            <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>
          ) : null}
        </div>
      </div>
      {moreTo ? (
        <Link
          to={moreTo}
          className="group inline-flex items-center gap-1 whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium text-foreground-600 transition-colors hover:bg-accent-100 hover:text-accent-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </Link>
      ) : null}
    </div>
  );
}